// some general functions for our leaflet maps


// Open all popups
// IN:
//UIT:
function openAllPopups() {
	for (var i = 0; i < numberOfMarkers; i++) {
		listOfMarkers[i].openPopup();
	}
}


// This only works on mobile/touch devices: It enables interaction with map when user taps on the map.
// Purpose: Avoid interference with page scrolling on small viewports.
// The zoom controls appear when the interaction is active as a clue to the user.
// IN: e - click event properties
//UIT:
function onTapEnableInteraction(e) {
	
	if ( !map.dragging.enabled() ) {
		map.dragging.enable();
		map.touchZoom.enable();
		if (map.tap) { 
			map.tap.enable();
		}

		// show zoom control
		$('.leaflet-control-zoom').toggle();
	}
}

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
